import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66cdb36c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "import-scan-screen" }
const _hoisted_2 = { class: "qr-wrapper mt-2 px-6 pb-6 pt-10" }

import { ref } from 'vue'

import ImportWizard from '@/popup/components/shared/Wizard.vue'
import QRCodeScan from '@/popup/components/shared/QRCode/QRCodeScan.vue'
import CodeTextareaSwitch from '@/popup/components/shared/QRCode/CodeTextareaSwitch.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportScan',
  setup(__props) {

const showQrCodeText = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ImportWizard, {
      title: _ctx.$t('import_wizard.import_scan'),
      progress: 20
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CodeTextareaSwitch, {
        "show-qr-code-text": showQrCodeText.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showQrCodeText.value = !showQrCodeText.value))
      }, null, 8 /* PROPS */, ["show-qr-code-text"]),
      _createVNode(QRCodeScan, {
        info: _ctx.$t('qr_code.scan.universal_profile_info'),
        "show-qr-code-text": showQrCodeText.value
      }, null, 8 /* PROPS */, ["info", "show-qr-code-text"])
    ])
  ]))
}
}

})